import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './assets/common/font.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './router'
import store from './store/index'
import i18n from './plugins/vueI18n'

Vue.use(VueAxios, axios)
Vue.use(vuetify)
Vue.config.productionTip = false
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
